import { store } from '../store';

const getInstanceConfig = () => {
  const { instance } = store.getState();
  return instance.instanceConfig;
}

export {
  getInstanceConfig
}


// WEBPACK FOOTER //
// ./src/helpers/instance_helpers.js